/*
 * Copyright (c) 2026. Bolmate B.V.
 */
import React from 'react';

import mail from '@iconify/icons-feather/mail';

import {useTranslation} from 'react-i18next';

import BolmateSetupCard from './bolmateSetupCard';

interface Props {
    completed?: boolean;
    onClick?: () => void;
    onCheckClick?: () => void;
    className?: string;
}

export default function BolmateEmailSetupCard(props: Props) {
    const {completed, onClick, onCheckClick, className} = props;
    const {t} = useTranslation();

    return (
        <BolmateSetupCard
            className={className}
            title={t('controls.setupCard.emailSetup.title', 'E-mails instellen')}
            subtitle={t('controls.setupCard.emailSetup.subtitle', 'Om automatisch te e-mailen')}
            icon={mail}
            completed={completed}
            onClick={onClick}
            onCheckClick={onCheckClick}
        />
    );
}
